<script setup lang="ts">
import { useQuasar } from 'quasar';
import BCard from 'shared/components/base/BCard/BCard.vue';
import {
  mdiWhiteBalanceSunny,
  mdiWeatherNight,
  mdiThemeLightDark,
} from '@quasar/extras/mdi-v7';
import { useTheme, type ThemeMode } from 'shared/composables/useTheme';

const $q = useQuasar();
const { themeMode } = useTheme();

const themeOptions: Array<{ label: string; value: ThemeMode; icon: string }> = [
  { label: 'THEME_LIGHT', value: 'light', icon: mdiWhiteBalanceSunny },
  { label: 'THEME_DARK', value: 'dark', icon: mdiWeatherNight },
  { label: 'THEME_SYSTEM', value: 'auto', icon: mdiThemeLightDark },
];
</script>

<template>
  <BCard
    size="sm"
    class="rounded-borders-xl"
    :class="$q.dark.isActive ? 'shadow-card-dark' : 'shadow-card bg-white'"
    :dark="$q.dark.isActive"
  >
    <q-card-section>
      <div class="text-h6">{{ $t('APPEARANCE') }}</div>
      <div class="text-caption text-muted">
        {{ $t('SELECT_APPEARANCE') }}
      </div>
    </q-card-section>

    <q-separator />

    <q-card-section>
      <q-btn-toggle
        v-model="themeMode"
        spread
        no-caps
        unelevated
        toggle-color="primary"
        :color="$q.dark.isActive ? 'grey-9' : 'grey-3'"
        :text-color="$q.dark.isActive ? 'grey-4' : 'dark'"
        :options="
          themeOptions.map((opt) => ({
            label: $t(opt.label),
            value: opt.value,
            icon: opt.icon,
          }))
        "
      />
    </q-card-section>
  </BCard>
</template>
